import { DATE_FORMATS } from "@/constants";
import { useDisclosure } from "@/hooks";
import { useUpdateContact } from "@/hooks/query-hooks/useContacts";
import { Button, Form, Modal } from "antd";
import dayjs from "dayjs";
import { ContactForm } from "./ContactForm";
import { createContactRequestSchema } from "@/constants/zod-schemas";

export function EditContactModal({
    contact,
}: {
    contact: Contact
}) {

    const [form] = Form.useForm();
    const [opened, { toggle }] = useDisclosure(false);

    const { mutate, isLoading } = useUpdateContact();

    const onToggleModal = () => {
        toggle();
        form.resetFields();
    };

    const onFinish = (values: CreateContactRequest) => {

        const { pickUpDate, pickUpTime, ...rest } = values;

        const data = {
            ...rest,
            pickUpDate: dayjs(pickUpDate).format(DATE_FORMATS.REQUEST_DATE_FORMAT),
            pickUpTime: dayjs(pickUpTime).format(DATE_FORMATS.REQUEST_TIME_FORMAT),
        }

        const payload = createContactRequestSchema.parse(data);

        mutate({
            id: contact.id,
            data: payload,
        }, {
            onSuccess: () => {
                onToggleModal();
            }
        })
    }

    return (
        <>
            <Button
                type="link"
                onClick={onToggleModal}
                size="small"
            >
                Edit
            </Button>
            <Modal
                open={opened}
                title="Edit Contact"
                onCancel={onToggleModal}
                okText="အတည်ပြုမည်"
                cancelText="ပယ်ဖျက်မည်"
                okButtonProps={{
                    form: `edit-contact-form-${contact.id}`,
                    htmlType: "submit",
                    type: "primary",
                    size: "large",
                    className: "bg-primary-gradient",
                    shape: "round",
                    loading: isLoading,
                }}
                cancelButtonProps={{
                    type: "text",
                    size: "large",
                    style: {
                        background: "transparent",
                    },
                    disabled: isLoading,
                }}
                width={640}
                maskClosable={false}
            >
                <ContactForm
                    initialValues={contact}
                    onFinish={onFinish}
                    form={form}
                    name={`edit-contact-form-${contact.id}`}
                />
            </Modal>
        </>
    )
}
